<template>
    <div class="land-location">
        <div class="container">
            <div class="land-section-title" v-if="salesCardPage != null">
                <h2>{{salesCardPage.land_site_section_titles.location}}</h2>
                <div class="location-adres">
                    <svg-icon icon-class="pin_land" className="icon-pin"/>
                    <p>{{salesCard.project_land_site.location_adres}}</p>
                </div>
            </div>
            <div class="land-location-map-mobile">
                <img :src="salesCard.project_land_site.location_img" alt="" id="sales-land-mobile-map">
            </div>
            <div class="land-location-img">
                <img :src="salesCard.project_land_site.location_img" alt="" v-if="lang != 'uz/'">
                <img :src="salesCard.project_land_site.location_img_uz" alt="" v-if="lang == 'uz/'">
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-location',
        components: {
        },
        data () {
            return {
                mobile: false,
                lang: window.GlobalLang,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
            initPinchZoomer() {
                var _self = this;
                var image = new Image();
                image.onload = function () {
                    if ($(window).width() < 800) {
                        $("#sales-land-mobile-map").pinchzoomer({
                            initZoom: 1,
                            minZoom: 1,
                        });
                    }
                }
                image.src = _self.salesCard.project_land_site.location_img;
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.initPinchZoomer();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-location.scss';
     @import '@/styles/respond/sales/sales-land-partials/land-location-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>